import {
    SET_POLYGONS,
    SET_EDITING_AREA,
    CREATE_PROSPECT,
    SET_MAP,
    SET_AREA,
    UNSET_PROSPECT,
    SET_ZOOM,
    CENTER_MAP,
    SET_PROVIDERS,
    SET_LOCAL_INIT,
    SET_LOCALE,
    UNSET_COORDINATES,
    GET_PROFILE,
    SET_PROVIDER,
    SET_USER,
    GET_GENERAL_CONFIGS,
    SET_GENERAL_CONFIGS,
    SET_ACCOUNT

} from './mutations';

import ProviderVuex from './modules/ProviderVuex'
import ProspectVuex from './modules/ProspectVuex'
import AccountVuex from './modules/AccountVuex'
import UserVuex from './modules/UserVuex'
import AreaVuex from './modules/AreaVuex'
import Vuex from 'vuex';
import Vue from 'vue';

import ProviderService from '../services/models/ProviderService';
import ConfigService from '../services/models/ConfigService';

const providerService = ProviderService.build();
const configService = ConfigService.build();

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        prospect: null,
        providers: null,
        has_area: false,
        zoom: 6,
        coordinates: null,
        local_init: false,
        center: {
            lat: -27.576493,
            lng: -48.527000,
        },
        user: {
            name: 'Anônimo',
        },
        map: {
            zoom: 6,
            markers: [],
        },
        locale: null,
        generalConfigs: {}
    },
    getters: {

        map: state => state.map,
        providers: state => state.providers,
        prospect: state => state.prospect,
        local_init: state => state.local_init,
        locale: state => state.locale,
        center: state => state.center,
        zoomMap: state => state.map.zoom,
        countries: state => state.countries,
        generalConfigs: state => state.generalConfigs,

    },
    mutations: {


        [SET_ZOOM]: (state, { zoom }) => {
            state.map.zoom = zoom;
        },
        [CENTER_MAP]: (state, { zoom = 18, ...coordinates }) => {

            state.map.zoom = zoom;
            state.map.setCenter({ lat: coordinates.lat, lng: coordinates.lng })
        },

        [SET_MAP]: (state, map) => {
            state.map = map;
        },
        [SET_AREA]: (state, has_area) => {
            state.has_area = has_area;
        },
        [SET_EDITING_AREA]: (state, editing_area) => {
            state.editing_area = editing_area;
        },
        [SET_POLYGONS]: (state, polygons) => {
            state.polygons = polygons;
        },
        [SET_LOCALE]: (state, locale) => {
            state.locale = locale;
        },
        [SET_PROVIDERS]: (state, providers) => {
            state.providers = providers;
        },
        [SET_LOCAL_INIT]: (state, newState) => {
            state.local_init = newState;
        },
        [CREATE_PROSPECT]: async (state, prospect) => {
            state.prospect = prospect;
        },
        [UNSET_PROSPECT]: (state) => {
            state.prospect = null;
            state.prospect_has_coordinates = false;
        },
        [UNSET_COORDINATES]: (state) => {
            state.center = { lat: -27.576493, lng: -48.527000 };
            state.map.zoom = 6;
        },
        [SET_GENERAL_CONFIGS]: (state, configs) => {
            state.generalConfigs = configs;
        },
    },
    actions: {

        [GET_PROFILE]: async ({ commit }) => {

            const response = await providerService.getMyData();

            commit(`AccountVuex/${SET_ACCOUNT}`, response.account);

            commit(`UserVuex/${SET_USER}`, response.user);

            if (response.provider) commit(`ProviderVuex/${SET_PROVIDER}`, response.provider);

            return response;
        },

        [GET_GENERAL_CONFIGS]: async ({ commit }) => {

            const response = await configService.getGeneralConfigs();

            commit(`${SET_GENERAL_CONFIGS}`, response);

            return response;

        },

    },
    modules: {
        ProviderVuex,
        ProspectVuex,
        AccountVuex,
        UserVuex,
        AreaVuex,
        
    },
});